module.exports = __webpack_public_path__ + "static/alpine-spas-112c95074fdae7027c194b24fd39f3db.jpg";